<ng-container *ngIf="articles$ | async as articles">
  <div class="card te-border-gradient-home">
    <app-article *ngFor="let article of articles; let select = index" [article]="article"></app-article>
  </div>
</ng-container>
